/**
 * @class
 */
export default class NotInStockError extends Error {
    constructor() {
        super("Sorry, none of the warehouses is having needed quantity you request yet");
        this.name = "NotInStockError";
    }
}